const buy = {
  id: '',
  account_id: '',
  store_id: '',
  customer_id: '',
  drs_buy_id: '',
  started_at: '',
  completed_at: '',
  status: '',
  created_at: '',
  updated_at: '',
  internal_note: '',
  sorter_id: '',
  signature_file_name: '',
  signature_content_type: '',
  signature_file_size: '',
  signature_updated_at: '',
  checked_in: '',
  closed_at: '',
  close_type: '',
  take_reasons: '',
  pass_reasons: '',
  checked_in_at: '',
  checked_in_by_employee_id: '',
  checkin_key: '',
  customer_flagged: '',
  customer_full_name: '',
  customer: {
    id: '',
    email: '',
    first_name: '',
    last_name: '',
    full_name: '',
    loyalty: '',
    phone_number: '',
    driver_license: {
      last_4: '',
      state: ''
    }
  }
}

export {
  buy
}



// WEBPACK FOOTER //
// ./src/store/models/buy.js